<!-- <div class="page-layout blank" style="min-height: inherit">
  <particle-workflow-wizard [workflowId]="workflowId" [apiEndpointKey]="apiEndpointKey"></particle-workflow-wizard>
</div> -->

<div  class=" full-grow-no-shrink-no-basis ">
  <particle-entity-selector
    [filterId]="filterId"
    [invalidateSubject]="invalidateSubject"
    [filterTemplateId]="filterTemplateId"
    [endpointName]="endpointName"
  >
  </particle-entity-selector>
</div>
